import React from "react";
import locale from "locale";
import {
    Modal,
    Row,
    Col,
    ButtonToolbar,
    Button,
    FormGroup,
    ControlLabel,
    FormControl,
    Checkbox,
} from "react-bootstrap";

const EventCalendarModal = ({
    calendarSettings,
    onChange,
    onPreview,
    onSave,
    onClose,
}) => {
    function isOnline() {
        return calendarSettings.type === "online";
    }

    function handleChange(propName, propValue) {
        onChange({ propName, propValue, type: calendarSettings.type });
    }

    function handleChangeAddress() {
        const checked = !calendarSettings.addAddress;

        handleChange("addAddress", checked);
        !checked && handleChange("address", null);
    }

    return (
        <Modal show={Boolean(calendarSettings)} bsSize="large">
            <Modal.Header>
                <Modal.Title>
                    {locale(
                        `email.${
                            isOnline()
                                ? "eventCalendarOnlineInfoModalLabel"
                                : "eventCalendarOfflineInfoModalLabel"
                        }`
                    )}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col xs={6}>
                        <FormGroup>
                            <ControlLabel>
                                {locale(
                                    "email.eventCalendarEventNameModalLabel"
                                )}{" "}
                                [Ru]
                            </ControlLabel>
                            <FormControl
                                value={calendarSettings.eventNameRu || ""}
                                onChange={({ target }) =>
                                    handleChange("eventNameRu", target.value)
                                }
                            />
                        </FormGroup>
                    </Col>
                    <Col xs={6}>
                        <FormGroup>
                            <ControlLabel>
                                {locale(
                                    "email.eventCalendarEventNameModalLabel"
                                )}{" "}
                                [En]
                            </ControlLabel>
                            <FormControl
                                value={calendarSettings.eventNameEn || ""}
                                onChange={({ target }) =>
                                    handleChange("eventNameEn", target.value)
                                }
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col xs={6}>
                        <FormGroup>
                            <ControlLabel>
                                {locale(
                                    "email.eventCalendarEventDescrModalLabel"
                                )}{" "}
                                [Ru]
                            </ControlLabel>
                            <FormControl
                                style={{
                                    minHeight: "150px",
                                    resize: "vertical",
                                }}
                                componentClass="textarea"
                                value={
                                    calendarSettings.eventDescriptionRu || ""
                                }
                                onChange={({ target }) =>
                                    handleChange(
                                        "eventDescriptionRu",
                                        target.value
                                    )
                                }
                            />
                        </FormGroup>
                    </Col>
                    <Col xs={6}>
                        <FormGroup>
                            <ControlLabel>
                                {locale(
                                    "email.eventCalendarEventDescrModalLabel"
                                )}{" "}
                                [En]
                            </ControlLabel>
                            <FormControl
                                style={{
                                    minHeight: "150px",
                                    resize: "vertical",
                                }}
                                componentClass="textarea"
                                value={
                                    calendarSettings.eventDescriptionEn || ""
                                }
                                onChange={({ target }) =>
                                    handleChange(
                                        "eventDescriptionEn",
                                        target.value
                                    )
                                }
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12}>
                        <Checkbox
                            value={calendarSettings.addLinkToDescription}
                            checked={calendarSettings.addLinkToDescription}
                            onChange={() =>
                                handleChange(
                                    "addLinkToDescription",
                                    !calendarSettings.addLinkToDescription
                                )
                            }
                        >
                            {locale(
                                `email.${
                                    isOnline()
                                        ? "eventCalendarOnlineAddLinkModalLabel"
                                        : "eventCalendarOfflineAddLinkModalLabel"
                                }`
                            )}
                        </Checkbox>
                    </Col>
                </Row>
                {!isOnline() && (
                    <Row>
                        <Col xs={12}>
                            <Checkbox
                                value={calendarSettings.addAddress}
                                checked={calendarSettings.addAddress}
                                onChange={handleChangeAddress}
                            >
                                {locale(
                                    "email.eventCalendarEventAddAddressModalLabel"
                                )}
                            </Checkbox>
                        </Col>
                    </Row>
                )}
                {calendarSettings?.addAddress && (
                    <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <ControlLabel>
                                    {locale(
                                        "email.eventCalendarEventAddressModalLabel"
                                    )}
                                </ControlLabel>
                                <FormControl
                                    value={calendarSettings.address || ""}
                                    onChange={({ target }) =>
                                        handleChange("address", target.value)
                                    }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                )}
            </Modal.Body>
            <Modal.Footer>
                <ButtonToolbar>
                    {/* <Button bsStyle="info" onClick={onPreview}>
                        {locale("email.watch")}
                    </Button> */}
                    <Button bsStyle="success" onClick={onSave}>
                        {locale("email.save")}
                    </Button>
                    <Button onClick={onClose}>{locale("email.close")}</Button>
                </ButtonToolbar>
            </Modal.Footer>
        </Modal>
    );
};

export default EventCalendarModal;
